import { useReduxState } from 'hooks';
import { EmailLog } from 'components/admin/logs';

const ProfileEmails = () => {
  const {
    pageState: { user }
  } = useReduxState();

  if (!user) return null;

  return <EmailLog isUserProfile={true} userId={user.id} />;
};

export default ProfileEmails;
